import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";

const FORM_ADDR = "https://readdy.ai/api/form/da1b560mlpfrg29fpf4g";

const footerCols = [
  {
    title: "番剧分类",
    links: [
      { label: "下饭番", to: "/biaoqian/xiafan" },
      { label: "摸鱼短番", to: "/biaoqian/moyu" },
      { label: "搞笑短篇", to: "/biaoqian/gaoxiao" },
      { label: "治愈系", to: "/biaoqian/zhiyu" },
    ],
  },
  {
    title: "看番指南",
    links: [
      { label: "一口气看完", to: "/biaoqian/yikouqi" },
      { label: "泡面三分钟", to: "/biaoqian/sanfen" },
      { label: "关于我们", to: "/about" },
      { label: "常见问题", to: "/faq" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<{ type: "idle" | "ok" | "error"; msg: string }>({ type: "idle", msg: "" });
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = String(formData.get("phone_alt") || "").trim();
    setLoading(true);

    if (honeypot) {
      setStatus({ type: "ok", msg: "订阅成功，感谢关注小水看番！" });
      setEmail("");
      setLoading(false);
      return;
    }
    formData.delete("phone_alt");

    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (res.ok && code === "OK") {
        setStatus({ type: "ok", msg: "订阅成功，最新短番盘点会第一时间送达你的邮箱。" });
        setEmail("");
      } else {
        setStatus({ type: "error", msg: serverMsg || "订阅失败，请稍后重试。" });
      }
    } catch {
      setStatus({ type: "error", msg: "网络异常，请稍后重试。" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <footer className="bg-primary-50 border-t border-primary-100">
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-bowl-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">小水看番</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注泡面番与三分钟短番的内容推荐站。按口味分好类，下饭番、摸鱼短番、日常搞笑短篇全收录，短篇速刷不迷路，一口气看完零负担。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className="ri-mail-line"></i>
              </span>
              <span className="text-sm text-foreground-700">hello@xiaoshuikanfan.com</span>
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">订阅新番盘点</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              每周一封短番推荐清单，第一时间知道有什么好看的泡面番和摸鱼短番。
            </p>
            <form
              id="newsletter-form"
              data-readdy-form="小水看番订阅表单"
              onSubmit={handleSubmit}
              className="mt-4"
            >
              <div className="flex flex-col gap-2 sm:flex-row">
                <label htmlFor="newsletter-email" className="sr-only">
                  你的邮箱
                </label>
                <input
                  id="newsletter-email"
                  name="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱"
                  className="h-11 flex-1 rounded-full border border-primary-200 bg-background-50 px-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="btn-pill bg-primary-500 text-background-50 hover:bg-primary-600 disabled:opacity-60"
                >
                  {loading ? "发送中…" : "订阅"}
                </button>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="frm-field-alt"
              />
              {status.type === "ok" && (
                <p className="mt-3 flex items-center gap-1.5 text-sm text-accent-700">
                  <i className="ri-checkbox-circle-line"></i>
                  {status.msg}
                </p>
              )}
              {status.type === "error" && (
                <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-700">
                  <i className="ri-error-warning-line"></i>
                  {status.msg}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-primary-100 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 小水看番 · 用短番装满每一段摸鱼时光
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://weibo.com"
              rel="nofollow noopener"
              target="_blank"
              aria-label="微博"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:text-primary-600"
            >
              <i className="ri-weibo-line"></i>
            </a>
            <a
              href="https://weixin.qq.com"
              rel="nofollow noopener"
              target="_blank"
              aria-label="微信"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:text-primary-600"
            >
              <i className="ri-wechat-line"></i>
            </a>
            <a
              href="https://bilibili.com"
              rel="nofollow noopener"
              target="_blank"
              aria-label="哔哩哔哩"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:text-primary-600"
            >
              <i className="ri-tv-2-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}